module.exports = __webpack_public_path__ + "static/media/tab-1.3b10b6b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/tab-1.png
// module id = 1251
// module chunks = 0